var en = {
    "not_found": {
        "title": "Page not found",
        "description": "This page does not exist or has been removed. Return to the homepage to continue browsing.",
        "countdown": "Returning to the homepage in {seconds} seconds",
        "return_home": "Return to homepage"
    },
    "languageArr": ["中", "EN", "JPN"],
    "login": "Log in",
    "search": {
        "title": "search",
        "cateArr": ["All", "Application market", "Product center", "News"],
        "placeholder": "Please enter keyword search",
        "record": "historical record"
    },
    "product_search": {
        "placeholder": "Please enter product name, product category, use, etc.",
        "btn": "search"
    },
    "statistics_arr": ["Technical expertise", "Patents", "R&D center area", "R&D personnel", "Scientific research institution"],
    "unit_arr": ["item", "item", "㎡", "+", "the"],
    "market_language": {
        "title": "Application market",
        "desc": "Focus on the application and solutions of high-end inorganic, non-metallic powder materials",
        "market": ["Electronic information materials", "New energy materials", "Semiconductor materials", "Other industries"],
        "btn": "Learn more"
    },
    "product_language": {
        "title": "Product center",
        "desc": "Customer-centric, adhere to innovation driven",
        "product": [
            { "name": "Silica", "desc": "Silicon micropowder, spherical silicon, spherical silicon slurry" }, 
            { "name": "Alumina", "desc": "Angular aluminum, spherical aluminum" }, 
            { "name": "Nitride", "desc": "Aluminum nitride, boron nitride" },
            { "name": "Titanium", "desc": "Single-crystal titanium dioxide" },
            { "name": "Ceramic", "desc": "Barium titanate, petalite" },
            { "name": "Conductive paste", "desc": "Sintered copper paste, curing copper paste" }
        ]
    },
    "group_introduction": {
        "title": "Company introduction",
        "inroduction": {
            "para1": "Suzhou Jinyi New Materials Technology Co., Ltd. was established in 2017 and is a national-level specialized and innovative 'small giant' enterprise. The company focuses on the field of advanced inorganic non-metallic powder materials. Its business predecessor can be traced back to Chongqing Jinyi founded in 2005. After more than twenty years of hard work, it has built a technical platform integrating powder synthesis, ultra-fine processing, spherical preparation, and surface modification. It comprehensively covers strategic emerging fields such as electronic information, thermal conductivity and heat dissipation, advanced coatings, and lithium-ion new energy, and has taken the lead in the inorganic functional powder for copper clad laminates field. Its sales scale has ranked first in the industry for consecutive years. The core product, electronic-grade high-purity ultra-fine spherical silicon powder, is widely used in the highest technical level copper clad laminates, such as Megtron 8-level high-speed copper clad laminates, IC carrier boards, and class S/LP (substrate-like carrier boards), and is suitable for high-end application scenarios such as AI servers.",
            "para2": "As a leading high-end powder material supplier in the industry, Jinyi New Materials has a global quality customer matrix. In the electronic information field, the company has established long-term and stable cooperation with the top twenty rigid copper clad board manufacturers worldwide, such as Taigu Electronics, Taoyu Technology, Jiantao Electronics, Lianmo Electronics, Nanyang Electronics, Japan Panasonic Electric, Shengyi Technology, Nanyang New Materials, etc. In the thermal conductivity and heat dissipation field, the company has established stable partnerships with international renowned thermal interface material enterprises like Henkel and Laird. In addition, the company's products have entered the supply chain of lithium-ion separators and leading high-end coatings enterprises, and has formed partnerships with world-renowned enterprises such as Enjie Co., Ltd. and AkzoNobel.",
            "para3": "The company's headquarters is located in Suzhou, Jiangsu Province, which is at the core hub of the Yangtze River Delta and has a trillion-yuan industrial cluster. It gathers top-notch research, education, and industry resources. The company attracts professionals from various fields and focuses on independent research and development and fundamental innovation, aiming to become a leader in the advanced inorganic non-metallic materials industry, making basic research a trend and making the independent control of key materials our mission."
        }
    },
    "core_advantage": {
        "title": "Core Strengths",
        "desc": "Creating customer value and realizing capital appreciation",
        "core_arr": [
            { "name": "Diverse technical expertise", "desc": "Compound formula, ultra-fine grinding<br />Precision grading, fine spheroidization<br />Surface treatment, customized slurry<br />" },
            { "name": "Various inorganic materials", "desc": "Based on inorganic, partnering with organic<br />Integration and innovation, renewal and iteration<br />" },
            { "name": "Lean Production Platform", "desc": "Flexible production, speedy delivery<br />Quality improvement, environmental protection<br />" },
            { "name": "Strict quality control", "desc": "Complete quality system<br />Advanced testing instruments<br />Excellent production equipment<br />Authoritative testing methods<br />" },
            { "name": "Customized Solutions", "desc": "Customer demand, joint research and development<br />Joint experiments, industry advantages<br />" },
            { "name": "Open Cooperation Platform", "desc": "Foreign-funded enterprises, state-owned enterprises<br />Research institutes, entrepreneurial teams<br />" }
        ]
    },
    "our_growth": {
        "title": "Our growth"
    },
    "company_culture": {
        "title": "Company culture",
        "culture": [
            { "title": "Vision", "desc": "High-end inorganic non-metallic material application and solution provider" },
            { "title": "Mission", "desc": "Focusing on the pressures and challenges of customer concerns, unlocking the potential of inorganic non-metallic materials" },
            { "title": "Values", "desc": "Customer-centered, innovation-driven, striver-oriented, and practicing the spirit of craftsmanship" }
        ]
    },
    "talent_concept": {
        "title": "Outlook on personnel",
        "concept": [
            { "title": "Professionalism", "desc": "Continuous learning, unity of knowledge and action<br />insisting on making the best use of talents and practicing the spirit of craftsmanship" },
            { "title": "Excellence", "desc": "forge ahead and strive for excellence<br />pursue the ultimate performance and achieve extraordinary value" },
            { "title": "Innovation", "desc": "openness and tolerance, embracing change<br />commitment to continuous improvement, and the courage to innovate" }
        ]
    },
    "school": {
        "title": "University-Enterprise Cooperation"
    },
    "development": {
        "title": "Career development",
        "desc1": "Ginet provides management and professional dual-channel career development path.",
        "desc2": "The professional channel includes 4 sequences of marketing, technology, function and operation."
    },
    "salary": {
        "title": "Remuneration and benefits",
        "salary_arr": [
            { "title": "Base salary", "desc": "Base salary, merits, full attendance bonus, allowances, subsidies" },
            { "title": "Social insurance", "desc": "the company equips “five insurance and one gold” for all employees" },
            { "title": "Life services", "desc": "accommodation, shuttle bus, cafeteria, sports and fitness venues available" },
            { "title": "Incentive mechanism", "desc": "year-end awards, project breakthrough awards, equity, option incentives, etc." },
            { "title": "Employee Development", "desc": "Diversified training programs and career development planning" }
        ],
        "btn": "Campus Recruitment"
    },
    "subsidiary": {
        "btn": "Learn More"
    },
    "honor": {
        "title": "Honor and qualification"
    },
    "wechat_code": "Official wechat account",
    "contact": {
        "contact_us": "Contact Us",
        "phone": "Contact number",
        "mail": "Mail",
        "address": "Add",
        "address_detail": "25-1 Xinggang Road, Changshu Economic and Technological Development Zone, Jiangsu Province, China",
        "copyright": "Copyright©️ 2024 Suzhou Ginet New Material Technology Co., Ltd",
        "download": "Download",
        "summary": "summary",
        "feature": "feature",
        "function": "function"
    },
    "fill_information": {
        "title": "Fill in the application information",
        "desc": "After filling in the information, automatically download the relevant product files",
        "not_null": "Not null",
        "name": "Name",
        "unit": "Unit Name",
        "department": "Department",
        "mail": "E-mail",
        "confirm": "confirm",
        "phone": "Contact number",
        "query": "Query",
        "select": "select",
        "content": "Content",
        "submit": "Submit"
    },
    "read_more": {
        "btn": "Read More"
    }
}

export default en
